import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { CognitoUser } from '@aws-amplify/auth';

import { ConfirmUserForm } from '../organisms';

import { getProfile, signOut } from '../../utils/auth-functions';
import CardHeader from '../organisms/CardHeader';
import useReturnUrl from '../../hooks/useReturnUrl';

export interface CognitoUserAttributes {
  name?: string;
  family_name?: string;
  nickname?: string;
  email?: string;
}

type CustomCognitoUser = CognitoUser & { attributes: CognitoUserAttributes };

export default function ConfirmUser(): ReactElement {
  const { search } = useLocation();
  const [firstLoad, setFirstLoad] = useState(true);
  const queryString = new URLSearchParams(search);
  const inApp = queryString.get('inApp');
  const redirectUrl = queryString.get('redirectUrl');
  const [profile, setProfile] = useState<CustomCognitoUser | string | undefined>(undefined);
  const history = useHistory();
  const returnUrl = useReturnUrl();

  useEffect(() => {
    const getProfileData = async () => {
      await getProfile().then((res) => {
        setProfile(res);
        setFirstLoad(false);
      });
    };
    getProfileData();
  }, []);

  useEffect(() => {
    if (!firstLoad) {
      if (profile && profile !== 'The user is not authenticated') {
        const goto = redirectUrl || returnUrl;
        if (goto) window.location.href = goto;
        else history.replace('/profile');
      } else if (profile === 'The user is not authenticated') {
        signOut();
      }
    }
  }, [profile]);

  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h2 className="card-title text-center py-1">Inserisci il codice ricevuto nella email</h2>
              <ConfirmUserForm inApp={inApp} redirectUrl={redirectUrl} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
